// extracted by mini-css-extract-plugin
module.exports = {"edit-button":"EditButton_edit-button__2MRmA","edit-button__icon":"EditButton_edit-button__icon__SY62c"};